import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  mainSiteByCustomerID: {},
  allSites: [],
  site: [],
  sitesByCustomerID: [],
  sitesBySelectedCustomerID: [],
  allSitesBySelectedCustomerID: [],
  newSite: null,
  updatedSite: null, // { index: index of site in sites table, updatedSite: updated site data }
  deletedSite: null, // Index of deleted site in sites table
  siteAccess: [],
  error: [],
  currentSite: { value: 'all sites', label: 'All Sites', key: 'all' },
};

const sitesSlice = createSlice({
  name: 'sites',
  initialState,
  reducers: {
    start: (state, action) => {
      state.error = [];
    },
    setReducerError: (state, action) => {
      state.error = action.payload;
    },
    setAllSites: (state, action) => {
      state.allSites = action.payload;
      state.error = [];
    },
    setSite: (state, action) => {
      state.site = action.payload;
      state.error = [];
    },
    setSiteAccess: (state, action) => {
      state.siteAccess = action.payload;
      state.error = [];
    },
    setSitesByCustomerID: (state, action) => {
      state.sitesByCustomerID = action.payload;
      state.error = [];
    },
    setSitesBySelectedCustomerID: (state, action) => {
      state.sitesBySelectedCustomerID = action.payload;
      state.error = [];
    },
    setAllSitesBySelectedCustomerID: (state, action) => {
      state.allSitesBySelectedCustomerID = action.payload;
      state.error = [];
    },
    setMainSiteByCustomerID: (state, action) => {
      state.mainSiteByCustomerID = action.payload;
      state.error = [];
    },
    setNewSite: (state, action) => {
      state.newSite = action.payload;
      state.error = [];
    },
    setUpdatedSite: (state, action) => {
      state.updatedSite = action.payload;
      state.error = [];
    },
    setDeletedSite: (state, action) => {
      state.deletedSite = action.payload;
      state.error = [];
    },
    resetSites: (state, action) => {
      state.site = [];
      state.error = [];
    },
    setCurrentSite: (state, action) => {
      state.currentSite = action.payload;
      state.error = [];
    },
    setResetSites: () => {
      return initialState;
    },
  },
});

export const {
  start,
  setReducerError,
  setAllSites,
  setSite,
  setSiteAccess,
  setSitesByCustomerID,
  setSitesBySelectedCustomerID,
  setAllSitesBySelectedCustomerID,
  setNewSite,
  setUpdatedSite,
  setDeletedSite,
  resetSites,
  setMainSiteByCustomerID,
  setCurrentSite,
  setResetSites,
} = sitesSlice.actions;

export default sitesSlice.reducer;
